import PropTypes from 'prop-types'
import React from 'react'
import Job from 'import/dto/Job'
import { useState } from 'react'
import IAEauAction from '../../../../iaeau/IAEauAction'
import { useDispatch } from 'react-redux'
import HydratecParamsPanel from '../../../../station/components/iaeauModels/modelParamsPanel/HydratecParamsPanel'


const ModelCalculJob = ({
    job = {},
    onExecute = () => {},
    onChangeJob = () => {},
}) => {
    const dispatch = useDispatch()
    const [model, setModel] = useState(undefined)
    if (job?.name?.toLowerCase()?.includes('hydratec')) {
        if (!model) {
            dispatch(IAEauAction.getModels('hydrometry', 33)).then(res => {
                setModel(res.find(m => m.typeModel === 'HYDRATEC'))
            })
            return null
        }
        return (
            <HydratecParamsPanel
                id={33}
                model={model}
                onExecute={onExecute}
                onChangeJob={onChangeJob}
            />
        )
    }
    return null
}

ModelCalculJob.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onExecute: PropTypes.func,
    onChangeJob: PropTypes.func,
}

export default ModelCalculJob
